module.exports = __webpack_public_path__ + "img/user-position.a39aae45.png";